import { AppProperties } from "./app-properties";

export class ServicesConstants {
  static readonly URL_LOGIN = AppProperties.BASEURL + '/login';
  static readonly URL_CAMBIOPASSWPRD = AppProperties.BASEURL + '/cambioPassword';

  static readonly URL_LOTTIPRODUZIONE = AppProperties.BASEURL + '/lottiProduzione';
  static readonly URL_LOTTISPEDIZIONE = AppProperties.BASEURL + '/lottiSpedizione';

  static readonly URL_STATICONSEGNA = AppProperties.BASEURL + '/statiConsegna';
  static readonly URL_BORSELLINIPRODOTTI = AppProperties.BASEURL + '/borselliniProdotti';

  static readonly URL_UTENTI = AppProperties.BASEURL + '/utenti';
  
  static readonly URL_DOCUMENTI = AppProperties.BASEURL + '/documenti/documenti';
  static readonly URL_PARAMETRI = AppProperties.BASEURL + '/parametri';
  
  static readonly URL_PARAMETRISERVIZI = AppProperties.BASEURL + '/parametriServizi';


  static readonly DEFAULT_DELAY_MS = 300;
  static readonly DEFAULT_MAX_RETRIES = 2;
}



// WEBPACK FOOTER //
// ./src/app/services-constants.ts